import script from "./useradd.vue?vue&type=script&lang=ts&setup=true"
export * from "./useradd.vue?vue&type=script&lang=ts&setup=true"

import "./useradd.vue?vue&type=style&index=0&id=f716f57c&lang=scss"

const __exports__ = script;

export default __exports__